import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Spin } from 'antd';
import SearchForm from './components/SearchForm'
import SearchResult from './components/SearchResult'
@inject('emailTemplateStore')
@observer
class emailAddress extends Component {
  render() {
    const { emailTemplateStore, location } = this.props
    const { isFetching } = emailTemplateStore
    return (
      <Spin spinning={isFetching}>
        <div className="container">
          <SearchForm location={location} />
          <SearchResult />
        </div>
      </Spin>
    );
  }
}
export default emailAddress;
